
    import { mapState, mapActions } from 'vuex';
    import debounce from 'lodash/debounce';
    import { ValidationObserver, ValidationProvider } from 'vee-validate';
    import Cookie from 'js-cookie';
    import datalayer from '@/utils/datalayer';
    import { jobData } from '@/utils/jobData';
    import C1FormInput from '@/C1Components/C1FormInput';

    export default {
        name: 'AuthEmail',

        components: {
            ValidationObserver,
            ValidationProvider,
            C1FormInput,
        },

        props: {
            email: {
                type: String,
                default: '',
            },

            hideLabel: {
                type: Boolean,
                default: false,
            },
        },

        data() {
            return {
                mail: '',
            };
        },

        computed: {
            ...mapState({
                $_authOptions: state => state.auth.authOptions,
                $_job: state => state.job.job,
                $_emailDebounce: state => state.auth.emailDebounce,
            }),

            isEmailInvalid() {
                return this.$_emailDebounce.is_validated && this.$_emailDebounce.is_invalid;
            },
        },

        watch: {
            mail() {
                this.validateEmail();
            },

            email(value) {
                if (value) {
                    this.setNewEmail();
                }
            },
        },

        created() {
            this.setNewEmail();
        },

        methods: {
            ...mapActions('user', {
                $_checkUserEmail: 'checkEmail',
            }),

            ...mapActions('eventTracking', {
                $_pushEvent: 'pushEvent',
            }),

            setGuestEmail() {
                const guestEmail = Cookie.get('guest_email');
                if (guestEmail !== 'undefined') {
                    this.mail = guestEmail || '';
                }
            },

            async validateEmail() {
                const validator = await this.$refs.formEmail.validate();
                if (validator) {
                    this.checkUserEmail();
                } else {
                    this.emitEmptyState();
                }
            },

            checkUserEmail: debounce(function() {
                this.$_checkUserEmail({ email: this.mail }).then((response) => {
                    this.$emit('user', response.data);
                    this.eventEmailRecognised();
                }).catch(async() => {
                    // Hack to remove user while user types
                    const v = await this.$refs.emailField.validate();
                    if (!v) {
                        this.emitEmptyState();
                    } else {
                        this.$emit('user', { email: this.mail });
                    }
                });
            }, 300),

            emitEmptyState() {
                this.$emit('user', {});
            },

            eventEmailRecognised() {
                const data = {
                    site_position: this.$_authOptions.sitePosition,
                    event: 'recognised_email_entered',
                    ...jobData(this.$_job),
                };
                datalayer(data);
                this.$_pushEvent(data);
            },

            setNewEmail() {
                if (this.email) {
                    this.mail = this.email;
                } else {
                    this.setGuestEmail();
                }
            },

            onInput() {
                this.$emit('input');
            },
        },
    };
